import React from 'react'
import Select, { OptionsType, components, createFilter } from 'react-select'
import { ReactComponent as SearchIcon } from '../../../assets/search.svg'
import { ReactComponent as CloseIcon } from '../../../assets/cross.svg'
import { CountryCell } from '../types'

interface Props {
  options: OptionsType<CountryCell>
  value: CountryCell | null
  onChange: (option: CountryCell) => void
}

export const SearchCountries: React.FC<Props> = ({ options, value, onChange }) => {
  const filterConfig = {
    ignoreCase: true,
    ignoreAccents: true,
    trim: false,
    matchFromStart: false,
  }

  return (
    <Select
      className="accsel-container"
      classNamePrefix="accsel"
      name="search"
      placeholder="Search a country"
      options={options}
      isClearable
      components={{ DropdownIndicator, ClearIndicator }}
      value={value}
      getOptionLabel={(option) => option.data.country}
      onChange={onChange as any}
      filterOption={createFilter(filterConfig)}
    />
  )
}

const DropdownIndicator = (props: any) => {
  return (
    <components.DropdownIndicator className="" {...props}>
      <SearchIcon className="" style={{ height: 24 }} />
    </components.DropdownIndicator>
  )
}

const ClearIndicator = (props: any) => {
  return (
    <components.ClearIndicator className="" {...props}>
      <CloseIcon className="" style={{ height: 24 }} />
    </components.ClearIndicator>
  )
}
